module.exports = __webpack_public_path__ + "img/dianchiReport4.f77dfb5a.png";